// extracted by mini-css-extract-plugin
export default {"cls1":"Stats-cls1_XXy","cls2":"Stats-cls2_Yue Stats-cls1_XXy"};